import React from "react";
import "./styles/tableStyles.css";

const LeagueTabHeading = ({ eyebrow, title, className = "" }) => (
    <div className={`league-tab-heading ${className}`}>
        {eyebrow && <p className="league-tab-heading-eyebrow">{eyebrow}</p>}
        <h2>{title}</h2>
    </div>
);

export default LeagueTabHeading;
